import React from 'react';
import { Breakpoint } from '@moda/om';
import { LineItem } from '../../hooks/useCart/cart.rest';
import { LineItemMiniGranularity } from '../LineItem/LineItemMini';
import { LineItemListFull } from './LineItemListFull';
import { LineItemListMini } from './LineItemListMini';

type Props = {
  size?: 'mini' | 'full';
  theme?: 'box' | 'simple';
  title?: string;
  subtitle?: string;
  items: LineItem[];
  showPriceWithVAT?: boolean;
  readOnly?: boolean;
};

export const LineItemList: React.FC<Props> = ({
  size = 'full',
  theme,
  title,
  subtitle,
  items,
  showPriceWithVAT,
  readOnly
}) => {
  if (size === 'mini')
    return (
      <LineItemListMini
        granularity={LineItemMiniGranularity.Minimal}
        title={title}
        subtitle={subtitle}
        theme={theme}
        items={items}
        showPriceWithVAT={showPriceWithVAT}
        readOnly={readOnly}
      />
    );

  return (
    <>
      <Breakpoint lt="md">
        <LineItemListMini
          showPriceWithVAT={showPriceWithVAT}
          title={title}
          subtitle={subtitle}
          theme={theme}
          items={items}
          readOnly={readOnly}
        />
      </Breakpoint>
      <Breakpoint gt="md">
        <LineItemListFull
          showPriceWithVAT={showPriceWithVAT}
          title={title}
          subtitle={subtitle}
          theme={theme}
          items={items}
          readOnly={readOnly}
        />
      </Breakpoint>
    </>
  );
};
